import React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import Tooltip from 'src/components/tooltip';
import {copy} from 'shared/utils';
import Icon from 'shared/components/icon';
import {flashTooltip} from 'src/redux/aptitude/actions';
import styles from './color-block.module.scss';

interface Props {
  color: {
    name: string;
    brand?: string;
    hex: string;
    variable: string;
  };
}

const ColorBlock = ({color: {name, hex, variable}}: Props) => {
  const dispatch = useDispatch();
  const tooltips = useSelector((state: {tooltips: Record<string, boolean>}) => state.tooltips);
  const showHexTooltip = !!tooltips[`color-block-${hex}`];
  const showVarTooltip = !!tooltips[`color-block-${variable}`];
  const showCopyTooltip = (id: string) => dispatch(flashTooltip(id));

  return (
    <li className={styles.container}>
      <div id="color-block" className={styles.swatch} style={{backgroundColor: hex}} />
      <label className={styles.name} htmlFor="color-block">
        {name}
      </label>
      <Tooltip title="Copied!" placement="top" open={showHexTooltip}>
        <button
          className={styles.hex}
          onClick={() => {
            copy(hex.toLowerCase().slice(1));
            showCopyTooltip(`color-block-${hex}`);
          }}
        >
          {hex}
          <Icon className={styles.copy} iconType="copy-r" />
        </button>
      </Tooltip>
      <Tooltip title="Copied!" placement="top" open={showVarTooltip}>
        <button
          className={styles.variable}
          onClick={() => {
            copy(variable);
            showCopyTooltip(`color-block-${variable}`);
          }}
        >
          <code className={styles.code}>{variable}</code>
          <Icon className={styles.copy} iconType="copy-r" />
        </button>
      </Tooltip>
    </li>
  );
};

export default ColorBlock;
